import React from 'react';
import Select from "react-select";
import { theme } from 'common/selectCustomStyles';
import { policyScopeOptions } from 'constants/global';
import { getSubNationalLabel, requiresPolicyType, supportsSubNational } from 'services/subNationalService';

const SubNationalSelector = ({ 
  formData, 
  handleInputChange, 
  setFormData,
  validationErrors,
  setValidationErrors,
  getDefaultValue,
  isLoading,
  errors,
  subNationalOptions,
  policyTypeOptions
}) => {

  const countryId = formData.policy_request_body?.country_id;

  // Determine if we need to show policy type dropdown
  const showPolicyType = requiresPolicyType(countryId);
  
  // Determine if we need to show policy scope dropdown
  const showPolicyScope = supportsSubNational(countryId);
  
  // Determine if we need to show sub-national dropdown
  const showSubNational = showPolicyScope && 
                          formData.policy_request_body?.policy_scope === "Sub-national";
  
  // Handle policy scope change
  const handlePolicyScopeChange = (option) => {
    handleInputChange("policy_scope", option.value);
    
    // If switched to National, clear any sub-national selections
    if (option.value === "National") {
      setFormData(prev => ({
        ...prev,
        policy_request_body: {
          ...prev.policy_request_body,
          sub_national_id: null
        }
      }));
      
      // Clear validation errors
      if (validationErrors) {
        setValidationErrors(prev => ({
          ...prev,
          subNationalID: undefined
        }));
      }
    }
  };

  // Handle sub-national selection change
  const handleSubNationalChange = (option) => {
    handleInputChange('sub_national_id', option?.value || null);
    
    // Clear validation error for this field
    setValidationErrors(prev => ({ 
        ...prev, 
        subNationalID: undefined 
    }));
  };

  return (
    <>
        {showPolicyType && (
            <div className="flex items-center">
            <label className="block text-sm">Policy Type*</label>
            <div className="ms-2" style={{ width: "100%" }}>
                <Select
                options={policyTypeOptions}
                value={getDefaultValue(
                    policyTypeOptions,
                    formData.policy_request_body.policy_type_id
                )}
                className={`basic-single`}
                classNamePrefix="select"
                placeholder="Select policy type"
                theme={theme}
                isLoading={isLoading.policyTypeOptions}
                onChange={(option) => {
                    handleInputChange("policy_type_id", option.value);
                    setValidationErrors(prev => ({ ...prev, policyTypeID: undefined }));
                }}
                />
                {(errors.policyTypeOptions || validationErrors.policyTypeID) && (
                  <span className="text-red-500 text-sm mt-1">
                    {errors.policyTypeOptions || validationErrors.policyTypeID}
                  </span>
                )}
            </div>
            </div>
        )}

        {showPolicyScope &&
            <>
                {/* Policy Scope Dropdown */}
                <div className="flex items-center">
                    <label className="block text-sm">Policy Scope*</label>
                    <div className="ms-2" style={{ width: "100%" }}>
                    <Select
                        options={policyScopeOptions}
                        value={getDefaultValue(
                            policyScopeOptions,
                            formData.policy_request_body.policy_scope
                          )}
                        className="basic-single"
                        classNamePrefix="select"
                        placeholder="Select policy scope"
                        theme={theme}
                        onChange={handlePolicyScopeChange}
                    />
                    {validationErrors?.policyScope && (
                        <span className="text-red-500 text-sm mt-1">
                            {validationErrors.policyScope}
                        </span>
                    )}
                    </div>
                </div>

                {/* Sub-national Dropdown */}
                {showSubNational && (
                    <div className="flex items-center">
                    <label className="block text-sm">
                        {getSubNationalLabel(countryId)}*
                    </label>
                    <div className="ms-2" style={{ width: "100%" }}>
                        <Select
                          options={subNationalOptions}
                          value={getDefaultValue(
                              subNationalOptions,
                              formData.policy_request_body.sub_national_id
                          )}
                          className="basic-single"
                          isLoading={isLoading.subNationalOptions}
                          classNamePrefix="select"
                          placeholder={`Select a ${getSubNationalLabel(countryId).toLowerCase()}`}
                          theme={theme}
                          onChange={handleSubNationalChange}
                        />
                        {(errors.subNationalOptions || validationErrors.subNationalID) && (
                            <span className="text-red-500 text-sm mt-1">
                                {errors.subNationalOptions || validationErrors.subNationalID}
                            </span>
                        )}
                    </div>
                    </div>
                )}
            </>
        }
    </>
  );
};

export default SubNationalSelector;